module.exports = __webpack_public_path__ + "img/homebannerbg1.2d8ec97c.png";